import { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "auto-bind/react";

import DialogWrapper from "../common/DialogWrapper";

import withStyles from "@mui/styles/withStyles";
import { Button } from "@mui/material";

const styles = theme => ({
  fileList: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
});

class UploadFileActionsDisabled extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    const { open, cancelAction } = this.props;

    if (!open) {
      return null;
    }

    return (
      <DialogWrapper
        open={true}
        title="Uploading files is temporarily unavailable. Please try again in a few minutes."
        cancelAction={cancelAction}
        buttons={({ cancelAction }) => (
          <>
            <Button variant="contained" color="primary" onClick={cancelAction}>
              Ok
            </Button>
          </>
        )}
      ></DialogWrapper>
    );
  }
}

UploadFileActionsDisabled.propTypes = {
  open: PropTypes.any.isRequired,
  cancelAction: PropTypes.func,
};

export default withStyles(styles)(UploadFileActionsDisabled);
